import { config } from "@/app/config";
import { resolveHost, type HostContext } from "@/domain/tenant/host";

/** Which tenant (or the platform console) the browser is currently on. Read at call time, not import time. */
export function currentHost(): HostContext {
  return resolveHost({
    hostname: window.location.hostname,
    search: window.location.search,
    allowOverride: import.meta.env.DEV,
    devTenant: config.devTenant,
    defaultSlug: config.defaultTenantSlug,
    rootDomain: config.rootDomain,
  });
}

/** Tenant slug sent with sign-in requests; `null` on the platform host (admins sign in with a password). */
export function currentTenantSlug(): string | null {
  const host = currentHost();
  return host.kind === "tenant" ? host.slug : null;
}
